<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    outlined
    :rounded="rounded"
    :dense="!$_isMobile"
    class="mb-5"
  />
</template>

<script>
export default {
  name: 'CoreTextField',

  props: {
    rounded: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
};
</script>
